<div class="detail__grid">
  <div class="detail__toolbar detail__toolbar--over"></div>
  <div class="detail__main">
    <kpd-collapse-panel title="{{ 'General' | translate }}" [collapsed]="false">
      <div class="flex-column form__column">
        <div class="form__control flex-row">
          <label>{{ 'Application' | translate }}:</label>
          <div class="form__input">
            <span>{{ item.application }}</span>
          </div>
        </div>
        <div class="form__control flex-row">
          <label class=" ">{{ 'Name' | translate }}:</label>
          <div class="form__input">
            <span>{{ item.name }}</span>
          </div>
        </div>

        <div class="form__control flex-row">
          <label class=" ">{{ 'Description' | translate }}:</label>
          <div class="form__input">
            <span>{{ item.description }}</span>
          </div>
        </div>
      </div>
    </kpd-collapse-panel>
  </div>
</div>
